module.exports = __webpack_public_path__ + "static/media/ban_main.ba689dd7.jpg";